import React, { useState, useLayoutEffect, useEffect } from "react";
import {
  Container,
  Form,
  Button,
  Card,
  Alert,
  Image,
  Spinner, // Add Spinner import
} from "react-bootstrap";
import companyLogo from "../../images/SimplyCoachFullLogo.png";
import { managerSignIn, getUserData, resetUserPassword } from "../../backend/firebaseFunctions";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import CoachPendingApproval from "../Coach Dashboard Components/CoachPendingApproval";
import CoachDisabled from "../Coach Dashboard Components/CoachDisabled";
import SignUpProcess from "./Sign Up Phases/SignUpProcess";

// Add custom styles
const customStyles = `
body, .auth-bg {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e0e7ff 100%);
  font-family: 'Inter', 'Roboto', 'Open Sans', Arial, sans-serif;
}

.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background: none;
}

.auth-card {
  border-radius: 32px;
  box-shadow: 0 8px 32px rgba(60, 72, 100, 0.18);
  padding: 3rem 2.5rem 2.5rem 2.5rem;
  background: #fff;
  max-width: 700px;
  width: 100%;
  margin: 0 auto;
  transition: box-shadow 0.2s;
}
.auth-card:hover {
  box-shadow: 0 12px 40px rgba(60, 72, 100, 0.22);
}
@media (max-width: 800px) {
  .auth-card {
    max-width: 98vw;
    padding: 2rem 0.5rem 1.5rem 0.5rem;
  }
}

.logo-img {
  width: 220px;
  height: auto;
  margin-bottom: 0.5rem;
}

.tagline {
  font-size: 1.15rem;
  color: #6c63ff;
  font-weight: 500;
  margin-bottom: 1.5rem;
  letter-spacing: 0.02em;
}

h2, h3, h5 {
  font-family: inherit;
  font-weight: 700;
  color: #22223b;
}

h2 {
  font-size: 2.1rem;
  margin-bottom: 0.5rem;
}

h3 {
  font-size: 1.4rem;
  margin-bottom: 1.2rem;
}

.form-label {
  font-size: 1.08rem;
  font-weight: 600;
  color: #3d405b;
}

.form-control {
  border-radius: 16px;
  padding: 0.85rem 1.1rem;
  font-size: 1.08rem;
  margin-bottom: 0.5rem;
  border: 1.5px solid #e0e7ff;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.form-control:focus {
  border-color: #6c63ff;
  box-shadow: 0 0 0 2px #e0e7ff;
}

.custom-toggle-group {
  display: inline-flex;
  background-color: #f3f4fa;
  border-radius: 16px;
  padding: 6px;
  margin: 0 auto 1.5rem auto;
  overflow: hidden;
}

.custom-toggle-button {
  border: none !important;
  font-weight: 600;
  font-size: 15px;
  min-width: 130px;
  background-color: transparent;
  color: #6c63ff;
  border-radius: 12px;
  transition: background 0.2s, color 0.2s;
}
.custom-toggle-button.active {
  color: #fff;
  background: linear-gradient(90deg, #6c63ff 0%, #48bb78 100%) !important;
  box-shadow: 0 2px 8px rgba(108, 99, 255, 0.08);
}
.custom-toggle-button:hover:not(.active) {
  background-color: #e0e7ff !important;
}

.btn-check:focus + .custom-toggle-button {
  box-shadow: none;
}

.option-card {
  transition: all 0.2s cubic-bezier(.4,2,.3,1);
  border: 2px solid transparent;
  border-radius: 18px !important;
  padding: 1.5rem 1rem 1rem 1rem;
  min-height: 120px;
  cursor: pointer;
  background: #f8fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 1.08rem;
  margin-bottom: 0.5rem;
}
.option-card .option-icon {
  font-size: 2.2rem;
  margin-bottom: 0.5rem;
}
.option-card.selected {
  background: linear-gradient(90deg, #6c63ff 0%, #48bb78 100%);
  color: #fff;
  border-color: #6c63ff;
  transform: scale(1.04) translateY(-2px);
  box-shadow: 0 4px 16px rgba(108, 99, 255, 0.10);
}
.option-card.selected .option-icon {
  color: #fff;
}
.option-card:hover:not(.selected) {
  background: #e0e7ff;
  border-color: #e0e7ff;
  transform: scale(1.02) translateY(-1px);
}

.btn-block, .w-100 {
  border-radius: 999px !important;
  font-size: 1.15rem;
  font-weight: 700;
  padding: 0.85rem 0;
  background: linear-gradient(90deg, #6c63ff 0%, #48bb78 100%);
  border: none;
  transition: background 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(108, 99, 255, 0.08);
}
.btn-block:disabled, .w-100:disabled {
  background: #bdbdbd !important;
  color: #fff !important;
  border: none;
}
.btn-block:hover:not(:disabled), .w-100:hover:not(:disabled) {
  background: linear-gradient(90deg, #48bb78 0%, #6c63ff 100%);
  box-shadow: 0 4px 16px rgba(108, 99, 255, 0.12);
}

.form-check-input[type="checkbox"] {
  border-radius: 6px;
  width: 1.2em;
  height: 1.2em;
  margin-right: 0.5em;
  accent-color: #6c63ff;
}

a {
  color: #6c63ff;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

a:hover {
  color: #5a52d5;
  text-decoration: underline;
  transform: translateY(-1px);
}

.alert {
  border-radius: 16px;
  font-size: 1.08rem;
  margin-top: 1.2rem;
  border: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.alert-success {
  background: linear-gradient(135deg, #d4edda 0%, #c3e6cb 100%);
  color: #155724;
  border-left: 4px solid #28a745;
}

.alert-danger {
  background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
  color: #721c24;
  border-left: 4px solid #dc3545;
}

.modern-link {
  color: #6c63ff;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.95rem;
  padding: 0.5rem 1rem;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8f9ff 0%, #e8ecff 100%);
  border: 1px solid #e0e7ff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.modern-link::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
  transition: left 0.5s;
}

.modern-link:hover {
  color: #5a52d5;
  text-decoration: none;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(108, 99, 255, 0.15);
  background: linear-gradient(135deg, #6c63ff 0%, #5a52d5 100%);
  color: white;
  border-color: #6c63ff;
}

.modern-link:hover::before {
  left: 100%;
}

.modern-link:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(108, 99, 255, 0.2);
}

.btn-loading {
  background: linear-gradient(90deg, #6c63ff 0%, #48bb78 100%) !important;
  opacity: 0.7;
  position: relative;
  overflow: hidden;
}

.btn-loading::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% { left: -100%; }
  100% { left: 100%; }
}

.password-input-container {
  position: relative;
}

.password-toggle-btn {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: color 0.2s;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
}

.password-toggle-btn:hover {
  color: #6c63ff;
}

.password-toggle-btn:focus {
  outline: none;
  color: #6c63ff;
}

.password-toggle-btn svg {
  width: 26px;
  height: 26px;
  fill: currentColor;
}
`;

const WelcomePage = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const { currentUser } = useAuth();

  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [showLogin, setShowLogin] = useState(!location.state?.showSignUp);
  const [loginError, setLoginError] = useState("");
  const [authenticating, setAuthenticating] = useState(false);
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [userType, setUserType] = useState("manager");
  const [showPendingApproval, setShowPendingApproval] = useState(false);
  const [showDisabledCoach, setShowDisabledCoach] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showNewSignUpProcess, setShowNewSignUpProcess] = useState(false);
  const [showLoginPassword, setShowLoginPassword] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetPasswordError, setResetPasswordError] = useState("");
  const [resetPasswordSuccess, setResetPasswordSuccess] = useState(false);
  const [sendingResetEmail, setSendingResetEmail] = useState(false);

  // Use useLayoutEffect to set scroll position before render
  useLayoutEffect(() => {
    if (location.state?.showSignUp) {
      setShowLogin(false);
      if (location.state?.selectedPackage) {
        setSelectedPackage(location.state.selectedPackage);
      }
      // Set scroll position before render
      window.scrollTo(0, 0);
    }
  }, [location.state]);

  // Redirect authenticated users to dashboard
  useEffect(() => {
    const redirectAuthenticatedUser = async () => {
      if (currentUser) {
        try {
          const userData = await getUserData(currentUser.uid);

          if (userData.userType === "coach") {
            if (userData.userStatus === "waitingForOrgAccept") {
              setShowPendingApproval(true);
              return;
            } else if (userData.userStatus === "disabled") {
              setShowDisabledCoach(true);
              return;
            }
          }

          // Special case for super user
          if (currentUser.email === "superuser@gmail.com") {
            navigate("/super_dashboard");
          } else {
            navigate(`dashboard/${currentUser.uid}`);
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
          // Don't redirect on error, let user stay on auth page
        }
      }
    };

    redirectAuthenticatedUser();
  }, [currentUser, navigate]);

  const translateAuthError = (error) => {
    const errorCode = error.code;
    switch (errorCode) {
      case "auth/user-not-found":
        return "משתמש לא קיים במערכת";
      case "auth/wrong-password":
        return "סיסמה שגויה";
      case "auth/invalid-email":
        return "כתובת אימייל לא תקינה";
      case "auth/email-already-in-use":
        return "כתובת אימייל כבר בשימוש";
      case "auth/weak-password":
        return "הסיסמה חלשה מדי. נא להזין סיסמה חזקה יותר";
      case "auth/network-request-failed":
        return "בעיית תקשורת. נא לבדוק את חיבור האינטרנט";
      case "auth/too-many-requests":
        return "יותר מדי ניסיונות התחברות. נא לנסות שוב מאוחר יותר";
      case "auth/operation-not-allowed":
        return "הפעולה לא מותרת";
      default:
        return "אירעה שגיאה. נא לנסות שוב";
    }
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    if (!loginEmail || !loginPassword) {
      setLoginError("נא להזין אימייל וסיסמה");
    } else {
      setLoginError("");
      setAuthenticating(true);
      try {
        const user = await managerSignIn(loginEmail, loginPassword);
        const userData = await getUserData(user.uid);

        if (userData.userType === "coach") {
          if (userData.userStatus === "waitingForOrgAccept") {
            setShowPendingApproval(true);
            return;
          } else if (userData.userStatus === "disabled") {
            setShowDisabledCoach(true);
            return;
          }
        }

        setLoginSuccess(true);

        // Special case for super user
        if (loginEmail === "superuser@gmail.com") {
          navigate("/super_dashboard");
        } else {
          navigate(`dashboard/${user.uid}`);
        }
      } catch (error) {
        setLoginError(translateAuthError(error));
        setLoginSuccess(false);
      } finally {
        setAuthenticating(false);
      }
    }
  };

  const handleSwitchForm = () => {
    setShowLogin(!showLogin);
    setLoginError("");
    setLoginSuccess(false);
    setShowPendingApproval(false);
    setShowDisabledCoach(false);
  };

  const handleStartNewSignUp = () => {
    setShowNewSignUpProcess(true);
  };

  const handleBackToLoginFromSignup = () => {
    setShowNewSignUpProcess(false);
    setShowLogin(true);
  };

  const handleSignupSuccess = async (user) => {
    try {
      const userData = await getUserData(user.uid);

      if (userData.userType === "coach") {
        if (userData.userStatus === "waitingForOrgAccept") {
          setShowPendingApproval(true);
          return;
        } else if (userData.userStatus === "disabled") {
          setShowDisabledCoach(true);
          return;
        }
      }

      // Special case for super user
      if (user.email === "superuser@gmail.com") {
        navigate("/super_dashboard");
      } else {
        navigate(`dashboard/${user.uid}`);
      }
    } catch (error) {
      console.error("Error fetching user data after signup:", error);
      // Don't redirect on error, let user stay on auth page
    }
  };

  const handleForgotPassword = () => {
    setShowForgotPassword(true);
    setResetPasswordError("");
    setResetPasswordSuccess(false);
    setResetEmail("");
  };

  const handleBackToLogin = () => {
    setShowForgotPassword(false);
    setResetPasswordError("");
    setResetPasswordSuccess(false);
    setResetEmail("");
  };

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    if (!resetEmail) {
      setResetPasswordError("נא להזין כתובת אימייל");
      return;
    }

    setSendingResetEmail(true);
    setResetPasswordError("");
    setResetPasswordSuccess(false);

    try {
      await resetUserPassword(resetEmail);
      setResetPasswordSuccess(true);
      setResetPasswordError("");
    } catch (error) {
      setResetPasswordError(error.message);
      setResetPasswordSuccess(false);
    } finally {
      setSendingResetEmail(false);
    }
  };

  return (
    <>
      <style>{customStyles}</style>
      <div className="auth-bg">
        {showPendingApproval ? (
          <CoachPendingApproval />
        ) : showDisabledCoach ? (
          <CoachDisabled />
        ) : (
          <Container className="py-5 auth-container" dir="rtl">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                width: "100%",
              }}
            >
              <div className="auth-card">
                <Card.Body
                  className="text-center"
                  style={{ padding: 0, background: "none" }}
                >
                  <Image
                    src={companyLogo}
                    alt="Company Logo"
                    className="logo-img"
                  />
                  {showLogin && (
                    <h2 className="font-weight-bold mb-4">ברוכים הבאים</h2>
                  )}

                  {showLogin ? (
                    showForgotPassword ? (
                      <Form onSubmit={handlePasswordReset}>
                        <h3 className="text-center mb-4">איפוס סיסמה</h3>
                        <p className="text-center text-muted mb-4">
                          הזן את כתובת האימייל שלך ונשלח לך קישור לאיפוס הסיסמה
                        </p>

                        <Form.Group
                          controlId="resetEmail"
                          style={{ marginBottom: "1rem" }}
                        >
                          <Form.Label>דואר אלקטרוני</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="הזן כתובת אימייל"
                            value={resetEmail}
                            onChange={(e) => setResetEmail(e.target.value)}
                            dir="rtl"
                          />
                        </Form.Group>

                        <Button
                          variant="primary"
                          type="submit"
                          className={`btn-block w-100 mb-3 ${sendingResetEmail ? 'btn-loading' : ''}`}
                          disabled={sendingResetEmail}
                        >
                          {sendingResetEmail ? (
                            <>
                              שולח...
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{ marginLeft: 8, marginRight: 8 }}
                              />
                            </>
                          ) : (
                            "שלח אימייל איפוס סיסמא"
                          )}
                        </Button>

                        <div className="text-center">
                          <button
                            type="button"
                            className="modern-link"
                            onClick={handleBackToLogin}
                          >
                            חזור להתחברות
                          </button>
                        </div>

                        {resetPasswordError && (
                          <Alert variant="danger" style={{ marginTop: "1rem" }}>
                            {resetPasswordError}
                          </Alert>
                        )}
                        {resetPasswordSuccess && (
                          <Alert variant="success" style={{ marginTop: "1rem" }}>
                            נשלח קישור איפוס סיסמה לכתובת האימייל שלך. נא לבדוק את תיבת הדואר הנכנס.
                            <br />
                            מומלץ לבדוק גם את תיבת ה-SPAM.
                          </Alert>
                        )}
                      </Form>
                    ) : (
                      <Form>
                        <h3 className="text-center mb-4">התחברות למערכת</h3>
                        <Form.Group
                          controlId="loginEmail"
                          style={{ marginBottom: "1rem" }}
                        >
                          <Form.Label>דואר אלקטרוני</Form.Label>
                          <Form.Control
                            type="email"
                            placeholder="הזן דואר אלקטרוני"
                            value={loginEmail}
                            onChange={(e) => setLoginEmail(e.target.value)}
                            dir="rtl"
                          />
                        </Form.Group>

                        <Form.Group
                          controlId="loginPassword"
                          style={{ marginBottom: "1rem" }}
                        >
                          <Form.Label>סיסמה</Form.Label>
                          <div className="password-input-container">
                            <Form.Control
                              type={showLoginPassword ? "text" : "password"}
                              placeholder="הזן סיסמה"
                              value={loginPassword}
                              onChange={(e) => setLoginPassword(e.target.value)}
                              dir="rtl"
                            />
                            <button
                              type="button"
                              className="password-toggle-btn"
                              onClick={() =>
                                setShowLoginPassword(!showLoginPassword)
                              }
                              aria-label={
                                showLoginPassword ? "הסתר סיסמה" : "הצג סיסמה"
                              }
                            >
                              {showLoginPassword ? (
                                <svg
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
                                </svg>
                              ) : (
                                <svg
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7 2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
                                </svg>
                              )}
                            </button>
                          </div>
                        </Form.Group>

                        <div className="text-center mb-3">
                          <button
                            type="button"
                            className="modern-link"
                            onClick={handleForgotPassword}
                          >
                            שכחתי סיסמה
                          </button>
                        </div>

                        <Button
                          variant="primary"
                          type="submit"
                          onClick={handleLoginSubmit}
                          className={`btn-block w-100 mb-3 ${authenticating ? 'btn-loading' : ''}`}
                          disabled={authenticating} // Disable while authenticating
                        >
                          {authenticating ? (
                            <>
                              טוען...
                              <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{ marginLeft: 8, marginRight: 8 }}
                              />
                            </>
                          ) : (
                            "התחברות"
                          )}
                        </Button>

                        <p className="text-center mt-3" >
                          אין לך חשבון?
                          <button
                            type="button"
                            className="modern-link"
                            onClick={handleSwitchForm}
                            style={{ marginRight: "0.5rem" }}
                          >
                            הירשם
                          </button>
                        </p>
                      </Form>
                    )
                  ) : showNewSignUpProcess ? (
                    <SignUpProcess
                      onBackToLogin={handleBackToLoginFromSignup}
                      initialUserType={userType}
                      initialPackage={selectedPackage}
                      onSignupSuccess={handleSignupSuccess}
                    />
                  ) : (
                    <div>
                      <h3 className="text-center mb-4">הרשמה למערכת</h3>
                      <p className="text-center text-muted mb-4">
                        לחץ על הכפתור למטה כדי להתחיל בתהליך ההרשמה
                      </p>

                      <div className="text-center mt-4">
                        <Button
                          variant="primary"
                          size="lg"
                          className="btn-block w-100"
                          onClick={handleStartNewSignUp}
                        >
                          התחל הרשמה
                        </Button>
                      </div>

                      <p className="text-center mt-3">
                        כבר יש לך חשבון?{" "}
                        <button
                          type="button"
                          className="modern-link"
                          onClick={handleSwitchForm}
                        >
                          התחבר
                        </button>
                      </p>
                    </div>
                  )}

                  {loginError && (
                    <Alert variant="danger" style={{ marginTop: "1rem" }}>
                      {loginError}
                    </Alert>
                  )}
                  {loginSuccess && (
                    <Alert variant="success">התחברת בהצלחה</Alert>
                  )}
                </Card.Body>
              </div>
            </div>
          </Container>
        )}
      </div>
    </>
  );
};

export default WelcomePage;
